import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
      '& .MuiButtonBase-root': {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
    'MuiToolbar-regular': {
      minHeight: '20px',
    },
  },
  RequestBtnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '0 16px',
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '0 16px',
  },
  tableContainer: {
  },
  totalIncome: {
    width: '100%',
    background: 'rgb(238, 241, 245)',
    padding: theme.spacing(2, 3),
    borderColor: '#d8d8d8',
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderStyle: 'solid',
  },
  totalIncomePrice: {
    fontWeight: 'bold',
    marginInlineStart: theme.spacing(1),
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color:'#2b3990',
    '&:hover':{
      background:'#2b3990',
      color: '#fff'
    }
  },
  notAvailabelBranch: {
    textAlign: 'center',
    padding: theme.spacing(3),
    fontWeight: 'bold',
    fontSize: 15,
  },
}));